import { OrderStatus } from '../api/orders';

const STYLES: Record<OrderStatus, string> = {
  pending: 'bg-slate-100 text-slate-700',
  accepted: 'bg-blue-100 text-blue-700',
  picked_up: 'bg-indigo-100 text-indigo-700',
  in_transit: 'bg-amber-100 text-amber-800',
  delivered: 'bg-emerald-100 text-emerald-700',
  cancelled: 'bg-slate-200 text-slate-600',
  failed: 'bg-red-100 text-red-700'
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: 'En attente',
  accepted: 'Acceptée',
  picked_up: 'Prise en charge',
  in_transit: 'En transit',
  delivered: 'Livrée',
  cancelled: 'Annulée',
  failed: 'Échouée'
};

export const StatusBadge = ({ status }: { status: OrderStatus }) => (
  <span className={`badge ${STYLES[status]}`}>{ORDER_STATUS_LABELS[status]}</span>
);
